import { useEffect, useState } from "react";
import classNames from "../../classNames";
import NotificationMenu from "../NotificationMenu";
import UserAvatar from "../UserAvatar";

const defaultProps = {
  navigateIcon: "bi bi-list",
};

function NavBar2({
  className,
  onClickNavigate,
  navigateIcon,
  logo,
  title,
  action,
  user,
  notificationCount,
  notifs,
  onViewAll,
  onClickProfile,
  onClickSettings,
  onClickLogout,
}) {
  const [notifications, setNotifications] = useState([]);
  const classes = classNames(className, "navbar navbar-expand-lg");
  const isAdmin = user?.roles.some((role) => role.id === "Admin");

  useEffect(() => {
    setNotifications(notifs);
  }, [notifs]);

  return (
    <nav className={classes}>
      <div className="container-fluid">
        <button
          onClick={onClickNavigate}
          type="button"
          className="btn btn-sm btn-link fs-4 ps-0 text-dark"
        >
          <i className={navigateIcon}></i>
        </button>

        <div className="d-flex align-items-center ms-auto gap-2">
          <>
            <NotificationMenu
              count={notificationCount}
              notifications={notifications}
              onViewAll={onViewAll}
            />
            <UserAvatar
              user={user}
              isAdmin={isAdmin}
              onClickProfile={onClickProfile}
              onClickSettings={onClickSettings}
              onClickLogout={onClickLogout}
            />
          </>
        </div>
      </div>
    </nav>
  );
}

NavBar2.defaultProps = defaultProps;
export default NavBar2;
